(function () {
  'use strict';

  class VariantDescription extends HTMLElement {
    constructor() {
      super();
      this.container = this.closest('[data-section-type="product"]');
      this.contentElement = this.querySelector('[data-variant-description-content]');
      this.descriptionsData = null;
      if (!this.container || !this.contentElement) return;
      this.init();
    }

    init() {
      var dataElement = this.container.querySelector('[data-variant-stone-descriptions]');
      if (!dataElement) return;
      try {
        this.descriptionsData = JSON.parse(dataElement.textContent.trim());
      } catch (e) {
        return;
      }
      var self = this;
      this.container.addEventListener('theme:variant:change', function (event) {
        if (event.detail && event.detail.variant && self.descriptionsData) {
          self.updateDescription(event.detail.variant.id);
        }
      });
    }

    updateDescription(variantId) {
      if (!this.descriptionsData || !this.contentElement) return;
      var id = variantId == null ? '' : String(variantId);
      var variantData = null;
      for (var i = 0; i < this.descriptionsData.length; i++) {
        if (String(this.descriptionsData[i].variant_id) === id) {
          variantData = this.descriptionsData[i];
          break;
        }
      }
      var html = '';
      if (variantData && typeof variantData.description === 'string' && variantData.description.trim() !== '') {
        html = variantData.description.replace(/''/g, '"');
      }
      this.contentElement.innerHTML = html;
      this.style.display = html ? '' : 'none';
    }
  }

  if (!customElements.get('variant-description')) {
    customElements.define('variant-description', VariantDescription);
  }
})();
